import React from 'react';
import { Button } from 'src/components/ui/button';
import { Account, Campaign } from '../types/client-management.types';
import SearchInput from 'src/components/search-input/search-input';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'src/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';

interface AccountCampaignMenubarProps {
  selectedFilter?: 'attention_needed' | 'all';
  searchQuery: string;
  filterSelect?: (filter: 'attention_needed' | 'all') => void;
  searchChange: (search: string) => void;
  className?: string;
  items: Account[] | Campaign[];
  label?: string;
}

const AccountCampaignMenubar: React.FC<AccountCampaignMenubarProps> = ({
  selectedFilter,
  filterSelect,
  searchQuery,
  searchChange,
  className,
  items,
  label,
}) => {

  // @ts-expect-error - items is an array of Account or Campaign
  const needsAttentionCount = items && items.length > 0 && items.filter((item: Account | Campaign) => item.attention_needed).length;
  // const activeCount = items?.filter((item: Account | Campaign) => !item.attention_needed).length;

  return (
    <div className="flex items-center justify-between w-full">
      <div className='flex items-center'>
        <SearchInput
          placeholder="Search advertisers, campaigns, line items..."
          value={searchQuery}
          onChange={searchChange}
          debounceMs={500}
          className="w-96"
          iconClassName='text-gray-600'
          inputClassName='bg-gray-201 rounded-full placeholder:text-gray-600'
        />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              className={`ml-2 ${className} hover:opacity-65 pr-5`}
              variant="ghost"
              size="med"
            >
              <ChevronDown className="w-4 h-4" />
              {selectedFilter === 'attention_needed' ? 'Attention Needed' : 'All'}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={() => filterSelect?.('attention_needed')}>
              Attention Needed
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => filterSelect?.('all')}>
              All
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className='flex items-center gap-2'>
        {label && (
          <div className='relative'>
            <span className='text-white bg-red-500 rounded-full px-1 items-center text-[10px] font-thin absolute top-0 right-0'>
              {Number(needsAttentionCount)}
            </span>

            <span className='text-gray-700 px-4 py-2 text-2xl font-thin'>
              {label}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountCampaignMenubar;
